define("preview-grid/components/main", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/template", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _template, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/template",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cPV--previewWrapper" data-test-id="preview-grid-main">
    <div
      class={{concat-classes "cPV--gridPanel" (if this.hasEditedPosts "has--changes")}}
      {{did-insert this.checkMultiplePosts}}
      ...attributes
    >
      <div class="cPV--filter">
        <span class="u--text--sm u--text--bold u--text--light">
          {{t "shared_words.show"}}
        </span>
        {{#each this.filters as |filter|}}
          {{#if filter.show}}
            <Shared::Ui::Button
              @additional="rounded"
              @class={{concat-classes "cPV--filter__btn" (if filter.isSelected "is--selected") filter.qaClass}}
              @onClick={{toggle-action filter.toggle this}}
              @variant="outline"
            >
              {{svg-jar filter.icon class="o--icon--sm u--m__r__xs"}}<span>{{filter.name}}</span>
            </Shared::Ui::Button>
          {{/if}}
        {{/each}}
      </div>
      <div class="cPV--phone at--visualPlanner__phone">
        {{#if this.hasEditedPosts}}
          <header class="cPV--phone__header has--changes u--fadeIn">
            <Shared::Ui::Button
              @additional="block"
              @isDisabled={{@isSaving}}
              @onClick={{@revertChanges}}
              @size="small"
              @text={{t "preview_grid.undo_all"}}
              @variant="outline"
            />
            <Shared::Ui::Button
              @additional="block"
              @isDisabled={{not @canSave}}
              @onClick={{@saveChanges}}
              @size="small"
              @text={{t "shared_phrases.save_changes"}}
              @variant="primary"
            />
          </header>
        {{/if}}
        <div class="cPV--phone__content h--perfectScrollbar" {{droppable onDrop=this.onDrop}} {{perfect-scroll}}>
          <div class="cPV--phone__header">
            <Shared::ProfileAvatar @size="large" @socialProfile={{@socialProfile}}>
              <p class="u--text--md u--m__b__0 u--m__t__xs">
                {{@socialProfile.name}}
              </p>
              <span class="u--text--bold">
                {{t "preview_grid.profile_nickname" nickname=@socialProfile.nickname}}
              </span>
            </Shared::ProfileAvatar>
          </div>
  
          <ul class="o--nav cPV--nav" data-test-id="ui-preview-planner-tabs">
            <li class="o--nav__item cPV--nav__item">
              <LinkTo
                @route="index"
                class={{concat-classes
                  "qa--plannerPreview_tabBtnFeed"
                  "o--nav__link cPV--nav__link"
                  (if this.isFeedTab "is--active")
                }}
              >
                {{svg-jar "ig-feed" class="o--icon cPV--nav__icon"}}
              </LinkTo>
            </li>
            <li class="o--nav__item cPV--nav__item">
              <LinkTo
                @route="reels"
                class={{concat-classes
                  "qa--plannerPreview_tabBtnReels"
                  "o--nav__link cPV--nav__link"
                  (if this.isReelsTab "is--active")
                  (if this.hasEditedPosts "o--btn--disabled")
                }}
              >
                {{svg-jar "ig-reels-outline" class="o--icon cPV--nav__icon"}}
              </LinkTo>
            </li>
          </ul>
  
          {{#if (and this.isFeedTab this.needReelsUpgrade)}}
            <div class="cPV--phone__infoBox--upgrade">
              {{svg-jar "ig-reels-outline" class="o--icon cPV--phone__infoBoxIcon"}}
              <div>
                <p class="u--m__b__0">{{t "preview_grid.reels.need_feed"}}</p>
                <Shared::Button::Upgrade
                  @feature="previewGrid"
                  @location="preview grid checkbox"
                  @text={{this.reelsUpgradeText}}
                  @trialText={{this.reelsUpgradeTrialText}}
                  @variant="actionLink"
                  class="u--text--success"
                />
              </div>
            </div>
          {{/if}}
  
          {{! Unable to display posts }}
          {{#if this.hasRateLimitError}}
            <div class="o--card u--m__xs" data-test-id="rate-limit-error">
              <div class="o--cardBody u--p__lr">
                <p class="u--text--bold">
                  {{t "preview_grid.unable_to_display_posts"}}
                </p>
                <p class="u--text--sm u--m__b__0">
                  {{t "preview_grid.reached_ig_api_limit"}}
                </p>
              </div>
            </div>
          {{/if}}
          {{! Max 60 Scheduled Posts Displayed }}
          {{#if this.reachedPostLimit}}
            <div class="o--card u--m__xs" data-test-id="post-limit">
              <div class="o--cardBody u--p__lr">
                <p class="u--text--bold u--m__b__xs">
                  {{t "preview_grid.max_posts_displayed_title"}}
                </p>
                <p class="u--text--sm u--m__b__0">
                  {{t "preview_grid.max_posts_displayed_message"}}
                </p>
              </div>
            </div>
          {{/if}}
  
          {{#if this.showDropCard}}
            <div class="o--mediaGrid__mediaWrapper">
              <figure class="o--mediaContainer">
                <div class="cDZ--dropzone">
                  <i class="cDZ--dropzone__text u--text--hl u--text--lg i-add-circle"></i>
                </div>
              </figure>
            </div>
          {{/if}}
          <div class="cPV--mediaGrid o--mediaGrid">
            {{#if (and this.isReelsTab this.needReelsUpgrade)}}
              <div class="o--blank u--p__lr">
                <p class="o--blank__title">
                  {{t "preview_grid.reels.trial_title"}}
                </p>
                <p class="o--blank__desc">
                  {{t "preview_grid.reels.trial_body"}}
                </p>
                <Shared::Button::Upgrade
                  @feature="previewGrid"
                  @location="preview grid reels tab"
                  @text={{if
                    this.isMobileSubscription
                    (t "plans.mobile.upgrade_your_plan" platform=this.platform)
                    (t "shared_phrases.upgrade_now")
                  }}
                  @trialText={{if
                    this.isMobileSubscription
                    (t "plans.mobile.upgrade_your_plan_trial" platform=this.platform)
                    (t "shared_phrases.upgrade_trial")
                  }}
                  @variant={{if this.isMobileSubscription "actionLink" "proceed"}}
                  class={{if this.isMobileSubscription "u--text--success"}}
                />
              </div>
            {{else}}
              <DragSortList
                @childClass={{this.cssMediaWrapperClass}}
                @dragEndAction={{this.updatePreviewPosts}}
                @draggingEnabled={{this.isFeedTab}}
                @isHorizontal={{true}}
                @items={{this.sortedEditablePosts}}
                as |post|
              >
                <Post @isFeedTab={{this.isFeedTab}} @post={{post}} @removePreviewPost={{this.removePreviewPost}} />
              </DragSortList>
  
              {{#each this.sortedLockedPosts as |post|}}
                <div class={{this.cssMediaWrapperClass}}>
                  <Post @isFeedTab={{this.isFeedTab}} @post={{post}} @removePreviewPost={{this.removePreviewPost}} />
                </div>
              {{/each}}
            {{/if}}
  
            {{#if (and this.isReelsTab @isDragging)}}
              <div class="o--blank cPV--mediaGrid__dragOverlay--warning">
                <p class="o--blank__title">
                  {{svg-jar "warning" class="o--icon--md u--m__r__xs"}}
                  {{t "preview_grid.reels.view_only.title"}}
                </p>
                <p class="o--blank__desc">
                  {{t "preview_grid.reels.view_only.desc"}}
                </p>
              </div>
            {{else if (and this.needsApproval @isDragging)}}
              <div class="o--blank cPV--mediaGrid__dragOverlay--warning">
                <p class="o--blank__title">
                  {{svg-jar "warning" class="o--icon--md u--m__r__xs"}}
                  {{t "preview_grid.reels.view_only.title"}}
                </p>
                <p class="o--blank__desc">
                  {{t "preview_grid.reels.view_only.missing_permission"}}
                </p>
              </div>
            {{/if}}
          </div>
  
          {{#if this.emptyPreview}}
            <div class="o--blank u--p__lr" data-test-id="empty-preview">
              <p class="o--blank__desc">
                {{#if this.isFeedTab}}
                  {{t "preview_grid.empty_preview"}}
                {{else if this.isReelsTab}}
                  {{html-safe (t "preview_grid.reels.empty_preview")}}
                {{/if}}
              </p>
            </div>
          {{/if}}
  
          {{! Unable to Load Feed }}
          {{#if (or this.feedNotLoaded this.hasIgUserError)}}
            <div class="o--card u--m__xs" data-test-id="unable-to-load-feed">
              <div class="o--cardBody u--p__lr">
                <p class="u--text--danger u--text--bold u--m__b__xs">
                  {{t "preview_grid.unable_to_load_feed_title"}}
                </p>
                <p class="u--text--danger u--text--sm u--m__b__0">
                  {{t "preview_grid.unable_to_load_feed_message"}}
                </p>
              </div>
            </div>
          {{/if}}
        </div>
      </div>
      {{! Share Schedule }}
      <div class={{concat-classes "cPV--footer" (if this.hasEditedPosts "u--mute")}}>
        <div class="o--btnBar">
          <span class="o--btnBar__text u--text--light">
            {{t "preview_grid.share_plan.intro"}}
          </span>
          <Shared::Ui::Button
            @class={{concat-classes
              "qa--preview_share_calendar_btn at—-shareCalendar__shareCalendarButton at--engagementShareCalendar__shareCalendarButton"
              (if this.hasEditedPosts "at—-shareCalendar__shareCalendarButtonDisabled")
            }}
            @isDisabled={{this.hasEditedPosts}}
            @onClick={{@makeSharePlan}}
            @text={{t "preview_grid.share_plan.create"}}
            @variant="outline"
          >
            {{t "preview_grid.share_plan.create"}}
            {{svg-jar "share" class="o--icon"}}
          </Shared::Ui::Button>
        </div>
      </div>
    </div>
  
    <PostScheduleSidebar
      @enableAutoSchedule={{@enableAutoSchedule}}
      @hasEditedPosts={{@hasEditedPosts}}
      @hasTimeSlots={{@hasTimeSlots}}
      @isFeedTab={{this.isFeedTab}}
      @isReelsTab={{this.isReelsTab}}
      @previewPosts={{this.visiblePosts}}
      @showQuickScheduleWizard={{@showQuickScheduleWizard}}
    />
  </div>
  */
  {
    "id": "BIuvzVpw",
    "block": "[[[10,0],[14,0,\"cPV--previewWrapper\"],[14,\"data-test-id\",\"preview-grid-main\"],[12],[1,\"\\n  \"],[11,0],[16,0,[28,[37,0],[\"cPV--gridPanel\",[52,[30,0,[\"hasEditedPosts\"]],\"has--changes\"]],null]],[17,1],[4,[38,2],[[30,0,[\"checkMultiplePosts\"]]],null],[12],[1,\"\\n    \"],[10,0],[14,0,\"cPV--filter\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--sm u--text--bold u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"shared_words.show\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"filters\"]]],null]],null],null,[[[41,[30,2,[\"show\"]],[[[1,\"          \"],[8,[39,6],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"rounded\",[28,[37,0],[\"cPV--filter__btn\",[52,[30,2,[\"isSelected\"]],\"is--selected\"],[30,2,[\"qaClass\"]]],null],[28,[37,7],[[30,2,[\"toggle\"]],[30,0]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,8],[[30,2,[\"icon\"]]],[[\"class\"],[\"o--icon--sm u--m__r__xs\"]]]],[10,1],[12],[1,[30,2,[\"name\"]]],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],null]],[2]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"cPV--phone at--visualPlanner__phone\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasEditedPosts\"]],[[[1,\"        \"],[10,\"header\"],[14,0,\"cPV--phone__header has--changes u--fadeIn\"],[12],[1,\"\\n          \"],[8,[39,6],null,[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[30,3],[30,4],\"small\",[28,[37,3],[\"preview_grid.undo_all\"],null],\"outline\"]],null],[1,\"\\n          \"],[8,[39,6],null,[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[28,[37,9],[[30,5]],null],[30,6],\"small\",[28,[37,3],[\"shared_phrases.save_changes\"],null],\"primary\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[11,0],[24,0,\"cPV--phone__content h--perfectScrollbar\"],[4,[38,10],null,[[\"onDrop\"],[[30,0,[\"onDrop\"]]]]],[4,[38,11],null,null],[12],[1,\"\\n        \"],[10,0],[14,0,\"cPV--phone__header\"],[12],[1,\"\\n          \"],[8,[39,12],null,[[\"@size\",\"@socialProfile\"],[\"large\",[30,7]]],[[\"default\"],[[[[1,\"\\n            \"],[10,2],[14,0,\"u--text--md u--m__b__0 u--m__t__xs\"],[12],[1,\"\\n              \"],[1,[30,7,[\"name\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"preview_grid.profile_nickname\"],[[\"nickname\"],[[30,7,[\"nickname\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,\"ul\"],[14,0,\"o--nav cPV--nav\"],[14,\"data-test-id\",\"ui-preview-planner-tabs\"],[12],[1,\"\\n          \"],[10,\"li\"],[14,0,\"o--nav__item cPV--nav__item\"],[12],[1,\"\\n            \"],[8,[39,13],[[16,0,[28,[37,0],[\"qa--plannerPreview_tabBtnFeed\",\"o--nav__link cPV--nav__link\",[52,[30,0,[\"isFeedTab\"]],\"is--active\"]],null]]],[[\"@route\"],[\"index\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,8],[\"ig-feed\"],[[\"class\"],[\"o--icon cPV--nav__icon\"]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"o--nav__item cPV--nav__item\"],[12],[1,\"\\n            \"],[8,[39,13],[[16,0,[28,[37,0],[\"qa--plannerPreview_tabBtnReels\",\"o--nav__link cPV--nav__link\",[52,[30,0,[\"isReelsTab\"]],\"is--active\"],[52,[30,0,[\"hasEditedPosts\"]],\"o--btn--disabled\"]],null]]],[[\"@route\"],[\"reels\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,8],[\"ig-reels-outline\"],[[\"class\"],[\"o--icon cPV--nav__icon\"]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[41,[28,[37,14],[[30,0,[\"isFeedTab\"]],[30,0,[\"needReelsUpgrade\"]]],null],[[[1,\"          \"],[10,0],[14,0,\"cPV--phone__infoBox--upgrade\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"ig-reels-outline\"],[[\"class\"],[\"o--icon cPV--phone__infoBoxIcon\"]]]],[1,\"\\n            \"],[10,0],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,3],[\"preview_grid.reels.need_feed\"],null]],[13],[1,\"\\n              \"],[8,[39,15],[[24,0,\"u--text--success\"]],[[\"@feature\",\"@location\",\"@text\",\"@trialText\",\"@variant\"],[\"previewGrid\",\"preview grid checkbox\",[30,0,[\"reelsUpgradeText\"]],[30,0,[\"reelsUpgradeTrialText\"]],\"actionLink\"]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"hasRateLimitError\"]],[[[1,\"          \"],[10,0],[14,0,\"o--card u--m__xs\"],[14,\"data-test-id\",\"rate-limit-error\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.unable_to_display_posts\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"u--text--sm u--m__b__0\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.reached_ig_api_limit\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"reachedPostLimit\"]],[[[1,\"          \"],[10,0],[14,0,\"o--card u--m__xs\"],[14,\"data-test-id\",\"post-limit\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--text--bold u--m__b__xs\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.max_posts_displayed_title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"u--text--sm u--m__b__0\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.max_posts_displayed_message\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showDropCard\"]],[[[1,\"          \"],[10,0],[14,0,\"o--mediaGrid__mediaWrapper\"],[12],[1,\"\\n            \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"cDZ--dropzone\"],[12],[1,\"\\n                \"],[10,\"i\"],[14,0,\"cDZ--dropzone__text u--text--hl u--text--lg i-add-circle\"],[12],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,0],[14,0,\"cPV--mediaGrid o--mediaGrid\"],[12],[1,\"\\n\"],[41,[28,[37,14],[[30,0,[\"isReelsTab\"]],[30,0,[\"needReelsUpgrade\"]]],null],[[[1,\"            \"],[10,0],[14,0,\"o--blank u--p__lr\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"o--blank__title\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.reels.trial_title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.reels.trial_body\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[8,[39,15],[[16,0,[52,[30,0,[\"isMobileSubscription\"]],\"u--text--success\"]]],[[\"@feature\",\"@location\",\"@text\",\"@trialText\",\"@variant\"],[\"previewGrid\",\"preview grid reels tab\",[52,[30,0,[\"isMobileSubscription\"]],[28,[37,3],[\"plans.mobile.upgrade_your_plan\"],[[\"platform\"],[[30,0,[\"platform\"]]]]],[28,[37,3],[\"shared_phrases.upgrade_now\"],null]],[52,[30,0,[\"isMobileSubscription\"]],[28,[37,3],[\"plans.mobile.upgrade_your_plan_trial\"],[[\"platform\"],[[30,0,[\"platform\"]]]]],[28,[37,3],[\"shared_phrases.upgrade_trial\"],null]],[52,[30,0,[\"isMobileSubscription\"]],\"actionLink\",\"proceed\"]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,16],null,[[\"@childClass\",\"@dragEndAction\",\"@draggingEnabled\",\"@isHorizontal\",\"@items\"],[[30,0,[\"cssMediaWrapperClass\"]],[30,0,[\"updatePreviewPosts\"]],[30,0,[\"isFeedTab\"]],true,[30,0,[\"sortedEditablePosts\"]]]],[[\"default\"],[[[[1,\"\\n              \"],[8,[39,17],null,[[\"@isFeedTab\",\"@post\",\"@removePreviewPost\"],[[30,0,[\"isFeedTab\"]],[30,8],[30,0,[\"removePreviewPost\"]]]],null],[1,\"\\n            \"]],[8]]]]],[1,\"\\n\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"sortedLockedPosts\"]]],null]],null],null,[[[1,\"              \"],[10,0],[15,0,[30,0,[\"cssMediaWrapperClass\"]]],[12],[1,\"\\n                \"],[8,[39,17],null,[[\"@isFeedTab\",\"@post\",\"@removePreviewPost\"],[[30,0,[\"isFeedTab\"]],[30,9],[30,0,[\"removePreviewPost\"]]]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[9]],null]],[]]],[1,\"\\n\"],[41,[28,[37,14],[[30,0,[\"isReelsTab\"]],[30,10]],null],[[[1,\"            \"],[10,0],[14,0,\"o--blank cPV--mediaGrid__dragOverlay--warning\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"o--blank__title\"],[12],[1,\"\\n                \"],[1,[28,[35,8],[\"warning\"],[[\"class\"],[\"o--icon--md u--m__r__xs\"]]]],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.reels.view_only.title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.reels.view_only.desc\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,14],[[30,0,[\"needsApproval\"]],[30,10]],null],[[[1,\"            \"],[10,0],[14,0,\"o--blank cPV--mediaGrid__dragOverlay--warning\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"o--blank__title\"],[12],[1,\"\\n                \"],[1,[28,[35,8],[\"warning\"],[[\"class\"],[\"o--icon--md u--m__r__xs\"]]]],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.reels.view_only.title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.reels.view_only.missing_permission\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]],null]],[]]],[1,\"        \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"emptyPreview\"]],[[[1,\"          \"],[10,0],[14,0,\"o--blank u--p__lr\"],[14,\"data-test-id\",\"empty-preview\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n\"],[41,[30,0,[\"isFeedTab\"]],[[[1,\"                \"],[1,[28,[35,3],[\"preview_grid.empty_preview\"],null]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isReelsTab\"]],[[[1,\"                \"],[1,[28,[35,18],[[28,[37,3],[\"preview_grid.reels.empty_preview\"],null]],null]],[1,\"\\n              \"]],[]],null]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,19],[[30,0,[\"feedNotLoaded\"]],[30,0,[\"hasIgUserError\"]]],null],[[[1,\"          \"],[10,0],[14,0,\"o--card u--m__xs\"],[14,\"data-test-id\",\"unable-to-load-feed\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--text--danger u--text--bold u--m__b__xs\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.unable_to_load_feed_title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"u--text--danger u--text--sm u--m__b__0\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"preview_grid.unable_to_load_feed_message\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,0],[15,0,[28,[37,0],[\"cPV--footer\",[52,[30,0,[\"hasEditedPosts\"]],\"u--mute\"]],null]],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"o--btnBar__text u--text--light\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"preview_grid.share_plan.intro\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,6],null,[[\"@class\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,0],[\"qa--preview_share_calendar_btn at—-shareCalendar__shareCalendarButton at--engagementShareCalendar__shareCalendarButton\",[52,[30,0,[\"hasEditedPosts\"]],\"at—-shareCalendar__shareCalendarButtonDisabled\"]],null],[30,0,[\"hasEditedPosts\"]],[30,11],[28,[37,3],[\"preview_grid.share_plan.create\"],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,3],[\"preview_grid.share_plan.create\"],null]],[1,\"\\n          \"],[1,[28,[35,8],[\"share\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[8,[39,20],null,[[\"@enableAutoSchedule\",\"@hasEditedPosts\",\"@hasTimeSlots\",\"@isFeedTab\",\"@isReelsTab\",\"@previewPosts\",\"@showQuickScheduleWizard\"],[[30,12],[30,13],[30,14],[30,0,[\"isFeedTab\"]],[30,0,[\"isReelsTab\"]],[30,0,[\"visiblePosts\"]],[30,15]]],null],[1,\"\\n\"],[13]],[\"&attrs\",\"filter\",\"@isSaving\",\"@revertChanges\",\"@canSave\",\"@saveChanges\",\"@socialProfile\",\"post\",\"post\",\"@isDragging\",\"@makeSharePlan\",\"@enableAutoSchedule\",\"@hasEditedPosts\",\"@hasTimeSlots\",\"@showQuickScheduleWizard\"],false,[\"concat-classes\",\"if\",\"did-insert\",\"t\",\"each\",\"-track-array\",\"shared/ui/button\",\"toggle-action\",\"svg-jar\",\"not\",\"droppable\",\"perfect-scroll\",\"shared/profile-avatar\",\"link-to\",\"and\",\"shared/button/upgrade\",\"drag-sort-list\",\"post\",\"html-safe\",\"or\",\"post-schedule-sidebar\"]]",
    "moduleName": "preview-grid/components/main.hbs",
    "isStrictMode": false
  });
  let MainComponent = _exports.default = (_dec = (0, _object.computed)('args.previewPosts.@each.{isRemoved,isReelsPost,isDraftPost,isReelsTab}', 'showReels', 'showDrafts', 'needReelsUpgrade', 'router.currentRouteName'), (_class = class MainComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _initializerDefineProperty(this, "userRole", _descriptor6, this);
      _defineProperty(this, "postLimit", 60);
      _initializerDefineProperty(this, "showReels", _descriptor7, this);
      _initializerDefineProperty(this, "showDrafts", _descriptor8, this);
    }
    get canCreateTimeSlots() {
      return !this.args.hasTimeSlots;
    }
    get canDropItems() {
      return this.args.enableAutoSchedule || this.canCreateTimeSlots;
    }
    get platform() {
      return this.subscriptions.platform;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get needsApproval() {
      return this.userRole.currentUser.needsApproval;
    }
    get noScheduledPosts() {
      return this.args.previewPosts.length === 0;
    }
    get hasEditedPosts() {
      return this.editedPosts.length > 0;
    }
    get editedPosts() {
      return this.args.previewPosts.filter(post => post.hasBeenEdited);
    }
    get editablePosts() {
      return this.visiblePosts.filter(post => post.canEdit);
    }
    get lockedPosts() {
      return this.visiblePosts.filter(post => !post.canMove);
    }
    get sortedEditablePosts() {
      return this.editablePosts.sortBy('queueOrder').reverse();
    }
    get sortedLockedPosts() {
      return this.lockedPosts.sortBy('queueOrder').reverse();
    }
    get cssMediaWrapperClass() {
      const baseWrapperCss = 'cPV--media o--mediaGrid__mediaWrapper';
      const tallWrapperCss = `${baseWrapperCss} o--mediaGrid__mediaWrapper--tall`;
      return this.isReelsTab ? tallWrapperCss : baseWrapperCss;
    }
    get visiblePosts() {
      let posts = this.args.previewPosts.filter(post => !post.isRemoved);
      if (this.auth.currentAccount.isOnLegacyPlan) {
        return posts.filter(post => !post.igPost?.isIGTV);
      }
      if (this.isReelsTab) {
        return !this.showDrafts ? posts.filter(post => post.isReelsPost && !post.isDraftPost) : posts.filter(post => post.isReelsPost);
      }
      if (this.needReelsUpgrade || !this.showReels) {
        posts = posts.filter(post => !post.isReelsPost);
      }
      if (!this.showDrafts) {
        posts = posts.filter(post => !post.isDraftPost);
      }
      return posts;
    }
    get emptyPreview() {
      return this.noScheduledPosts && !this.hasScheduledPostError && !this.feedNotLoaded;
    }
    get feedNotLoaded() {
      return (this.hasIgPostError || this.hasMissingPosts) && !this.hasRateLimitError;
    }
    get hasMissingPosts() {
      return this.args.igPosts?.get('length') === 0 && this.args.igUser?.mediaCount > 0;
    }
    get hasMultiplePostsScheduledAtSameTime() {
      const allScheduledTimes = {};
      if (this.args.existingPosts) {
        const numExistingPosts = this.args.existingPosts.length;
        for (let i = 0; i < numExistingPosts; i++) {
          const post = this.args.existingPosts.objectAt(i);
          const {
            scheduledTime
          } = post;
          if (allScheduledTimes[scheduledTime]) {
            return true;
          }
          allScheduledTimes[scheduledTime] = true;
        }
      }
      return false;
    }
    get hasIgPostError() {
      return Boolean(this.args.errors.find(error => error === 'igPostError'));
    }
    get hasRateLimitError() {
      return Boolean(this.args.errors.find(error => error === 'rateLimitError'));
    }
    get hasScheduledPostError() {
      return Boolean(this.args.errors.find(error => error === 'scheduledPostError'));
    }
    get hasIgUserError() {
      return Boolean(this.args.errors.find(error => error === 'igUserError'));
    }
    get showDropCard() {
      if (this.emptyPreview || this.isReelsTab) {
        return false;
      }
      return this.args.isDragging && this.args.enableAutoSchedule;
    }
    get reachedPostLimit() {
      return this.args.existingPosts?.get('length') >= this.postLimit;
    }
    get needReelsUpgrade() {
      return !this.auth.currentAccount.canInstagramReels;
    }
    get isFeedTab() {
      return this.router.currentRouteName === 'cluster.schedule.preview-grid.index';
    }
    get isReelsTab() {
      return this.router.currentRouteName === 'cluster.schedule.preview-grid.reels';
    }
    get reelsUpgradeText() {
      return this.isMobileSubscription ? this.intl.t('plans.mobile.upgrade_your_plan', {
        platform: this.platform
      }) : this.intl.t('shared_phrases.upgrade_now');
    }
    get reelsUpgradeTrialText() {
      return this.isMobileSubscription ? this.intl.t('plans.mobile.upgrade_your_plan', {
        platform: this.platform
      }) : this.intl.t('shared_phrases.upgrade_trial');
    }
    get filters() {
      return [{
        icon: 'ig-reels-outline',
        isSelected: this.showReels,
        name: this.intl.t('shared_words.reels'),
        qaClass: 'qa--plannerPreview_filterReels',
        show: !this.isReelsTab && !this.needReelsUpgrade,
        showNewIcon: false,
        toggle: 'showReels'
      }, {
        icon: 'draft-post',
        isSelected: this.showDrafts,
        name: this.intl.t('shared_words.drafts'),
        qaClass: 'qa--plannerPreview_filterDrafts',
        show: true,
        showNewIcon: true,
        toggle: 'showDrafts'
      }];
    }
    removePreviewPost(previewPost) {
      this.args.removeNewPreviewPost(previewPost);
      previewPost.remove();
    }
    onDrop(dragEvent) {
      // Note: Avoid dropping media on the preview grid - reels tab
      if (this.isReelsTab) {
        this.alerts.warning((0, _template.htmlSafe)(this.intl.t('preview_grid.reels.cant_quick_schedule')), {
          preventDuplicates: true
        });
        return;
      }
      if (this.needsApproval) {
        this.alerts.warning((0, _template.htmlSafe)(this.intl.t('preview_grid.no_permission.description')), {
          title: this.intl.t('preview_grid.no_permission.title'),
          preventDuplicates: true
        });
        return;
      }
      const draggedElement = dragEvent.target;
      const droppedItemIds = dragEvent.dataTransfer.getData('text');
      if (draggedElement.classList.contains('e--post__new') || draggedElement.classList.contains('e--post__scheduled') || !this.canDropItems) {
        return;
      }
      if (this.canCreateTimeSlots) {
        this.args.showQuickScheduleWizard();
      } else {
        this.args.droppedElements(droppedItemIds);
      }
    }
    checkMultiplePosts() {
      if (this.hasMultiplePostsScheduledAtSameTime) {
        this.alerts.alert(this.intl.t('alerts.preview_grid.multiple_posts_scheduled_same_time.message'), {
          title: this.intl.t('alerts.preview_grid.multiple_posts_scheduled_same_time.title')
        });
      }
    }
    updatePreviewPosts(_ref) {
      let {
        sourceList,
        sourceIndex,
        targetList,
        targetIndex
      } = _ref;
      if (sourceList === targetList && sourceIndex === targetIndex) return;
      const item = sourceList.objectAt(sourceIndex);
      const originalList = sourceList.map(a => ({
        ...a
      }));
      sourceList.removeAt(sourceIndex);
      targetList.insertAt(targetIndex, item);
      targetList.forEach((post, index) => {
        const originalPost = originalList.objectAt(index);
        post.set('scheduledTime', originalPost.scheduledTime);
        post.set('queueOrder', originalPost.queueOrder);
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userRole", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showReels", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showDrafts", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "visiblePosts", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "visiblePosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removePreviewPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removePreviewPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDrop", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkMultiplePosts", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "checkMultiplePosts"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MainComponent);
});